var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / calendar-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M3.7478 6V20C3.7478 20.5304 3.95852 21.0391 4.33359 21.4142C4.70866 21.7893 5.21737 22 5.7478 22H19.7478C20.2782 22 20.7869 21.7893 21.162 21.4142C21.5371 21.0391 21.7478 20.5304 21.7478 20V6C21.7478 5.46957 21.5371 4.96086 21.162 4.58579C20.7869 4.21071 20.2782 4 19.7478 4H17.7478V2H15.7478V4H9.7478V2H7.7478V4H5.7478C5.21737 4 4.70866 4.21071 4.33359 4.58579C3.95852 4.96086 3.7478 5.46957 3.7478 6ZM19.7478 20H5.7478V8H19.7478V20Z",
    fill: "#4D4E50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default __webpack_public_path__ + "static/media/calendar-alt.d9754606ec68164c05cbcec4c3a6e2c8.svg";
export { ForwardRef as ReactComponent };